import apiClient from "../utils/apiClient";

class VipService {
  async getDailyStatus() {
    const res = await apiClient.get("/api/casino/vip/daily-status");
    return res.data;
  }

  async claimDaily(rewardType) {
    const res = await apiClient.post("/api/casino/vip/claim-daily", {
      rewardType,
    });

    // Emit event to update indicators
    if (res.data) {
      window.dispatchEvent(
        new CustomEvent("vip-daily-claimed", {
          detail: { rewardType, data: res.data },
        }),
      );
    }

    return res.data;
  }
}

const vipService = new VipService();
export default vipService;
